import styled from 'styled-components';

import { Colors } from '~/styles/Metrics';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 100vw;
  background: ${Colors.White};
`;
